import router from "@/employee/routes";
import { watch } from "@vue/composition-api";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useBiometricAuthStore } from "@/shared/store/biometricAuth";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { AccountsSummary, Home, BiometricAuthSettings } from "@/employee/route-names";
import { setAnalyticsUser } from "@/shared/pinia-gtm";
import { annotateLogsWithCurrentUser } from "@/shared/datadog";

export function hsabLoginWatch () {
    const userStore = useUserStore();
    const hsabAccountsStore = useHsabAccountsStore();
    const biometricAuthStore = useBiometricAuthStore();
    const custodianSettingsStore = useCustodianSettingsStore();

    watch(() => userStore.loggedIn, userLoggedIn => {
        setAnalyticsUser(!userStore.loggedIn);
        annotateLogsWithCurrentUser();
        const isHsaBank = custodianSettingsStore.isHsaBankCustodian;
        if (userLoggedIn && isHsaBank) {
            if (hsabAccountsStore.isWexOnlyAccount) {
                hsabAccountsStore.navigateToWex();
            } else if (biometricAuthStore.redirectToSetup) {
                router.push({ name: BiometricAuthSettings });
            } else if (hsabAccountsStore.hsaAccounts.length > 0 && hsabAccountsStore.notionalAccounts.length < 1) {
                router.push({ name: Home });
            } else {
                router.push({ name: AccountsSummary });
            }
        }
    });
}